import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultType, JudgmentResultEnum } from "../../types.client";
import { parseRangeValue } from "../../utils/parseValue.utils";
import { IoSignalLevelMeasure } from "../../../models/schemas/measures/communication.schema";

/**
 * 기기 입출력 신호레벨 컨트롤러
 * 판정 기준: 입력/출력 각각 범위 내 확인
 */
export class IoSignalLevelController extends MeasureController<IoSignalLevelMeasure> {
  protected getDefaultData(): IoSignalLevelMeasure {
    return {
      inputStandard: "",
      inputMeasured: 0,
      outputStandard: "",
      outputMeasured: 0,
      unit: "dBuV",
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
    };
  }

  protected judge(): JudgmentResult {
    const { inputStandard, inputMeasured, outputStandard, outputMeasured } = this.data;

    // 데이터 미입력 시
    if (
      !inputStandard ||
      !outputStandard ||
      inputMeasured === undefined ||
      inputMeasured === null ||
      outputMeasured === undefined ||
      outputMeasured === null
    ) {
      return {
        result: JudgmentResultEnum.NA,
        discussion: this.generateDiscussion(JudgmentResultEnum.NA),
      };
    }

    // parseRangeValue 사용
    const inputRange = parseRangeValue(inputStandard);
    const outputRange = parseRangeValue(outputStandard);

    if (!inputRange || !outputRange) {
      return {
        result: JudgmentResultEnum.NA,
        discussion: "기준값 파싱 실패 (올바른 범위 형식: '60~80 dBuV')",
      };
    }

    // 입력/출력 각각 판정
    const inputOk = inputMeasured >= inputRange.min && inputMeasured <= inputRange.max;
    const outputOk = outputMeasured >= outputRange.min && outputMeasured <= outputRange.max;

    // 둘 다 정상이어야 GOOD
    const result: JudgmentResultType =
      inputOk && outputOk ? JudgmentResultEnum.GOOD : JudgmentResultEnum.BAD;

    return {
      result,
      discussion: this.generateDiscussion(result),
    };
  }

  protected generateDiscussion(result: JudgmentResultType): string {
    if (result === JudgmentResultEnum.NA) {
      return "데이터 미입력";
    }

    const { inputStandard, inputMeasured, outputStandard, outputMeasured } = this.data;
    const inputRange = parseRangeValue(inputStandard);
    const outputRange = parseRangeValue(outputStandard);

    if (
      !inputRange ||
      !outputRange ||
      inputMeasured === undefined ||
      outputMeasured === undefined
    ) {
      return "기준값 또는 측정값 파싱 실패";
    }

    const inputOk = inputMeasured >= inputRange.min && inputMeasured <= inputRange.max;
    const outputOk = outputMeasured >= outputRange.min && outputMeasured <= outputRange.max;

    if (result === JudgmentResultEnum.GOOD) {
      return "입출력 신호레벨이 모두 기준 범위 내에 있음";
    }

    const issues: string[] = [];
    if (!inputOk) {
      issues.push(`입력: ${inputMeasured} dBuV (정상: ${inputRange.min}~${inputRange.max} dBuV)`);
    }
    if (!outputOk) {
      issues.push(
        `출력: ${outputMeasured} dBuV (정상: ${outputRange.min}~${outputRange.max} dBuV)`
      );
    }

    return `신호레벨 범위 이탈 - ${issues.join(", ")}`;
  }
}
